// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--jwL2O571knXldCYA","wrapperFlat":"wrapper-flat--oO9FqKqz1kUg1zHF","blockEmployer":"block-employer--Myft4sEZDG8OJ3V2","question":"question--tOVCUARPGBEfT4NA"};